import colorConfigs from "../../configs/colorConfigs";

const smartFridgeStyles = {
  submitButton: {
    mt: 3,
    mb: 2,
    color: colorConfigs.secondary,
    backgroundColor: colorConfigs.primary,
    '&:hover': {
      backgroundColor: colorConfigs.primary,
    },
    borderRadius: '30px',
    width: {xs:'60%', sm:'20%'},
  },
};

export default smartFridgeStyles;